import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { validateAddress } from "@faire/retailer-visitor-shared/lib/validation";
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { createStoreHook } from "@faire/web--source/ui/hooks/useStore";
import isEmpty from "lodash/isEmpty";
import keys from "lodash/keys";
import omit from "lodash/omit";
import { action, computed, observable } from "mobx";
var FIELDS_TO_VALIDATE = [
    "name",
    "address1",
    "city",
    "state",
    "postal_code",
    "phone_number"
];
export var CheckoutShippingAddressStore = /*#__PURE__*/ function() {
    "use strict";
    function CheckoutShippingAddressStore() {
        var _this = this;
        _class_call_check(this, CheckoutShippingAddressStore);
        this.externalErrors = {};
        this.setAddress = function(address) {
            _this.externalErrors = {};
            _this.address = address;
        };
        this.destroy = function() {
            _this.address = {};
            _this.externalErrors = {};
        };
        this.setErrors = function(errors) {
            _this.externalErrors = errors;
        };
        this.assign = function(address) {
            _this.clearExternalErrors(keys(address));
            _this.address = _object_spread({}, _this.address, address);
        };
        this.clearExternalErrors = function(fields) {
            _this.externalErrors = omit(_this.externalErrors, fields);
        };
        makeObservable(this);
    }
    _create_class(CheckoutShippingAddressStore, [
        {
            key: "isExistingAddress",
            get: function get() {
                return !!this.address.token;
            }
        },
        {
            key: "isValid",
            get: /*
     * Validation and Errors
     */ function get() {
                return isEmpty(this.errors);
            }
        },
        {
            key: "errors",
            get: function get() {
                return _object_spread({}, this.invalidFormFields, this.externalErrors);
            }
        },
        {
            key: "invalidFormFields",
            get: function get() {
                return validateAddress(this.address, FIELDS_TO_VALIDATE);
            }
        }
    ]);
    return CheckoutShippingAddressStore;
}();
CheckoutShippingAddressStore.get = singletonGetter(CheckoutShippingAddressStore);
__decorate([
    observable
], CheckoutShippingAddressStore.prototype, "address", void 0);
__decorate([
    observable
], CheckoutShippingAddressStore.prototype, "externalErrors", void 0);
__decorate([
    computed
], CheckoutShippingAddressStore.prototype, "isExistingAddress", null);
__decorate([
    computed
], CheckoutShippingAddressStore.prototype, "isValid", null);
__decorate([
    computed
], CheckoutShippingAddressStore.prototype, "errors", null);
__decorate([
    computed
], CheckoutShippingAddressStore.prototype, "invalidFormFields", null);
__decorate([
    action
], CheckoutShippingAddressStore.prototype, "setErrors", void 0);
__decorate([
    action
], CheckoutShippingAddressStore.prototype, "assign", void 0);
__decorate([
    action
], CheckoutShippingAddressStore.prototype, "clearExternalErrors", void 0);
export var useCheckoutShippingAddressStore = createStoreHook(CheckoutShippingAddressStore);
